import { z } from 'zod';
import { idInput, paginationInput } from './common';

// ===== COMISSAO =====
export const createComissaoInput = z.object({
  nome: z.string().min(2, 'Nome deve ter no minimo 2 caracteres'),
  descricao: z.string().optional(),
  eventoId: z.string().uuid().optional(),
  campanhaId: z.string().uuid().optional(),
}).refine(
  (data) => (data.eventoId && !data.campanhaId) || (!data.eventoId && data.campanhaId),
  { message: 'Informe eventoId OU campanhaId', path: ['eventoId'] }
);

export const updateComissaoInput = idInput.extend({
  nome: z.string().min(2).optional(),
  descricao: z.string().optional(),
});

export const listComissoesInput = paginationInput.extend({
  eventoId: z.string().uuid().optional(),
  campanhaId: z.string().uuid().optional(),
});

// ===== MEMBRO =====
export const createMembroInput = z.object({
  comissaoId: z.string().uuid(),
  userId: z.string().uuid().optional(),
  nome: z.string().min(2, 'Nome deve ter no minimo 2 caracteres'),
  funcao: z.string().min(2, 'Funcao deve ter no minimo 2 caracteres'),
  telefone: z.string().optional(),
  email: z.string().email('Email invalido').optional().or(z.literal('')),
  observacao: z.string().optional(),
});

export const updateMembroInput = idInput.extend({
  userId: z.string().uuid().nullable().optional(),
  nome: z.string().min(2).optional(),
  funcao: z.string().min(2).optional(),
  telefone: z.string().optional(),
  email: z.string().email().optional().or(z.literal('')),
  observacao: z.string().optional(),
});

export const listMembrosInput = paginationInput.extend({
  comissaoId: z.string().uuid(),
});

// Types
export type CreateComissaoInput = z.infer<typeof createComissaoInput>;
export type UpdateComissaoInput = z.infer<typeof updateComissaoInput>;
export type ListComissoesInput = z.infer<typeof listComissoesInput>;
export type CreateMembroInput = z.infer<typeof createMembroInput>;
export type UpdateMembroInput = z.infer<typeof updateMembroInput>;
export type ListMembrosInput = z.infer<typeof listMembrosInput>;
